import { useEffect } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { deleteCommentApi, deleteThreadApi } from "../services/thread";
import { deleteTopicApi } from "../services/topic";
import { banUserApi, unbanUserApi } from "../services/user";

export type Props = {
  show: boolean;
  userId: string;
  id: number | null;
  onToggle: (b: boolean) => void;
  selectedIndex: (n: number) => void;
  deleteType: string;
};

const Confirmation = (props: Props) => {
  const { topicId } = useParams();
  let navigate = useNavigate();
  const deleteComment = async () => {
    const response = await deleteCommentApi(props.id!);
    if (response.status === 200) {
      window.location.reload();
    }
  };

  const deleteThread = async () => {
    const response = await deleteThreadApi(props.id!, props.userId);
    if (response.status === 200) {
      navigate(`/forum/${topicId}`);
    }
  };

  const deleteTopic = async () => {
    const response = await deleteTopicApi(props.id!, props.userId);
    if (response.status === 200) {
      window.location.reload();
    }
  };

  const banUser = async () => {
    const response = await banUserApi(props.id!, props.userId);
    if (response.status === 200) {
      window.location.reload();
    }
  };

  const unbanUser = async () => {
    const response = await unbanUserApi(props.id!, props.userId);
    if (response.status === 200) {
      window.location.reload();
    }
  };

  const changePassword = async () => {
    const response = await deleteTopicApi(props.id!, props.userId);
    if (response.status === 200) {
      navigate(`/forum/${topicId}`);
    }
  };
  
  return (
    <>
      {props.onToggle ? (
        <>
          <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-3xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-start justify-between p-5 border-b border-solid border-slate-200 rounded-t mt-5">
                  <p className="text-3xl font-semibold">
                    Are you sure you want to delete?
                  </p>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
                  {props.deleteType == "deleteComment" ? (
                    // props.threadId==-1 ?
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={deleteComment}
                    >
                      Yes
                    </button>
                  ) : props.deleteType == "deleteThread" ? (
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={deleteThread}
                    >
                      Yes
                    </button>
                  ) : props.deleteType == "deleteTopic" ? (
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={deleteTopic}
                    >
                      Yes
                    </button>
                  ) : props.deleteType == "banUser" ? (
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={banUser}
                    >
                      Yes
                    </button>
                  ) : props.deleteType == "unbanUser" ? (
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={unbanUser}
                    >
                      Yes
                    </button>
                  ) : (
                    <button
                      className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
                      type="button"
                      onClick={changePassword}
                    >
                      Yes
                    </button>
                  )}
                  <button
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                    type="button"
                    onClick={() => {
                      props.onToggle(false);
                      props.selectedIndex(-1);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
};

export default Confirmation;
